module.exports = __webpack_public_path__ + "img/030.cff9323e.jpg";